export default __webpack_public_path__ + "static/media/headershadow.0e316947.svg";